// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fM","homeTitle_styleDefault":"c-a_fN","homeTitle_styleRed":"c-a_fO"};